/**
 * 页面：首页
 * 链接：https://www.liepin.com/
*/


// 引入polyfill
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { Adslot4Pc } from '@liepin/native-adslot-fe';
// 公用样式
import '../../common/styles';
// 公用头尾侧栏
import '../../components/SiderBar';
import '../../includes/seo-header';
// 非SEO部分
import './modules/render-search-bar';
import './modules/render-login';
import './modules/render-login-bottom';
// 样式
import './styles/common.less';
import './styles/home-banner.less';
import './styles/home-industry.less';
import './styles/home-comp.less';
import './styles/home-hot-jobs.less';
// 逻辑
import '../../includes/common-hot-links'; // 热链交互及样式
import './modules/common';
import './modules/home-industry';
import './modules/home-hot-jobs';
// 显示im
import '../../common/js/lib/load-im';
// tlog统计
import './modules/tlog';


// eslint-disable-next-line no-new
new Adslot4Pc();

